<template>
  <el-dialog
    title="批量修改"
    class="batch-update-dialog"
    width="70%"
    :visible.sync="visible"
    @close="dialogClose"
  >
    <el-input autofocus v-model="value" type="textarea" :rows="16"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="confirmBatchUpdate">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { MSG } from "../utils/utils";

export default {
  name: "batchUpdateDialog",
  data() {
    return {
      visible: false,
      value: ""
    };
  },
  props: ["dialogShow", "batchOptionUpdate"],
  watch: {
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    },
    batchOptionUpdate: {
      handler(val) {
        this.value = val;
      }
    }
  },
  methods: {
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    confirmBatchUpdate() {
      this.$emit("update:dialogShow", false);
      this.$emit("update:batchOptionUpdate", this.value);
      this.$emit("confirm");
    }
  }
};
</script>


<style lang="scss" scoped>
.changeEditType {
  strong {
    color: #f0614e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/batchUpdateDialog.vue